module.exports = __webpack_public_path__ + "img/cards.149c8e8f.svg";